import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { ToolModel } from "../../../shared/entities/tool.model";
import { CustomerModel } from "../../../shared/entities/customer.model";
import { SaleModel } from "../../../shared/entities/sale.model";
import { ClientModel } from "../../../shared/entities/client.model";
import { LocalStorageService } from "../localStorage/local-storage.service";

@Injectable()
export class DataService {
	private adminToolData = new BehaviorSubject<ToolModel>(undefined!);
	currentAdminToolData = this.adminToolData.asObservable();

	private adminClientData = new BehaviorSubject<ClientModel>(undefined!);
	currentAdminClientData = this.adminClientData.asObservable();

	public adminCustomerData = new BehaviorSubject<CustomerModel>(undefined!);
	currentAdminCustomerData = this.adminCustomerData.asObservable();

	public adminSaleData = new BehaviorSubject<SaleModel>(undefined!);
	currentAdminSaleData = this.adminSaleData.asObservable();

	constructor(private localStorageService: LocalStorageService) {}

	public saveModelData(tool: ToolModel): void {
		this.localStorageService.setAdminToolData(tool);
	}

	public saveCustomerData(customer: CustomerModel): void {
		this.localStorageService.setAdminCustomerData(customer);
	}

	public saveClientdata(client: ClientModel): void {
		this.localStorageService.setAdminClientData(client);
	}

	public getAdminToolData(): ToolModel {
		return this.localStorageService.getAdminToolData()!;
	}

	public getAdminCustomerData(): CustomerModel {
		return this.localStorageService.getAdminCustomerData()!;
	}

	public getAdminClientData(): ClientModel {
		return this.localStorageService.getAdminClientData()!;
	}

	public updateAdminToolData(tool: ToolModel): void {
		this.adminToolData.next(tool);
	}

	public updateAdminCustomerData(customer: CustomerModel): void {
		this.adminCustomerData.next(customer);
	}

	public updateAdminSaleData(sale: SaleModel): void {
		this.adminSaleData.next(sale);
	}

	public updateAdminClientData(client: ClientModel): void {
		this.adminClientData.next(client);
	}
}
